// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div {
  min-height: 100px;
}

.grid-item-beige {
  background-color: beige;
}

.grid-item-red {
  background-color: red;
}

.grid-item-yellow {
  background-color: yellow;
}`, "",{"version":3,"sources":["webpack://./projects/mydocma/dynamic-form/src/lib/layouts/flex-layout/flex-layout/flex-layout.component.scss","webpack://./../mydocma-dynamic-form-app%20(dev)/projects/mydocma/dynamic-form/src/lib/layouts/flex-layout/flex-layout/flex-layout.component.scss"],"names":[],"mappings":"AAAA;EACI,iBAAA;ACCJ;;ADEA;EACI,uBAAA;ACCJ;;ADEA;EACI,qBAAA;ACCJ;;ADEA;EACI,wBAAA;ACCJ","sourcesContent":["div {\r\n    min-height: 100px;\r\n}\r\n\r\n.grid-item-beige {\r\n    background-color: beige;\r\n}\r\n\r\n.grid-item-red {\r\n    background-color: red;\r\n}\r\n\r\n.grid-item-yellow {\r\n    background-color: yellow;\r\n}\r\n\r\n","div {\n  min-height: 100px;\n}\n\n.grid-item-beige {\n  background-color: beige;\n}\n\n.grid-item-red {\n  background-color: red;\n}\n\n.grid-item-yellow {\n  background-color: yellow;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
